import React, { useRef, useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { useNavigate } from "react-router-dom";
import { CForm, CFormLabel, CFormInput, CButton } from '@coreui/react';
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';



const urlApi = '/storage_elements';
const urlRouter = '/storage-element';
const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}`, 'accept': 'application/json' } }


export async function LoaderStorageElementUpdate({ params }) {
  if (Object.keys(params).length != 0) {
    let res = await AxiosInstance.get(`${urlApi}/${params.pid}`).then((response) => {
      return response;
    });
    return res;
  }
  return false;
};

const formReducer = (state, event) => {
  return {
    ...state,
    [event.target.name]: event.target.value
  }
};

const StorageElementForm = () => {
  const navigate = useNavigate();
  const { data } = useLoaderData();
  const [name, setName] = useState((data != undefined) ? data.name : '');
  const [description, setDescription] = useState((data != undefined) ? data.description : '');
  const [c1id, setC1id] = useState((data != undefined) ? data.c1id : '');
  const [isMain, setIsMain] = useState((data != undefined) ? data.isMain : false);
  const [storage, setStorage] = useState((data != undefined) ? { label: data.storage.name, value: data.storage.id } : {});
  const editorRef = useRef(null);
  // Ключ для Editor
  const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;
  // const [defaultAccountManager, setDefaultAccountManager] = useState({});

  // useEffect(() => {
  //   if(data = undefined)
  //     setStorage({label: result.storage.name, value: result.storage.id});
  // }, [data]);

  const loadOptionsAcc = async (inputValue) => {
    let rez = await AxiosInstance.get(`/storages?name=${inputValue}`, { headers: { 'accept': 'application/json' } }).then((response) => {
      return response.data.map((result) => ({
        label: result.name,
        value: result.id
      }));
    });
    // setDefaultAccountManager(rez);
    return rez;
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
      const data_response = {
        name: name,
        description: editorRef.current.getContent(),
        c1Id: c1id,
        isMain: isMain,
        storage: `/api/storages/${storage.value}`
      };
      if (data != undefined) {
        const response = AxiosInstance.put(`${urlApi}/${data.id}`, data_response, header).then((response) => {
          if (response.status === 200)
            return navigate(urlRouter);
        });
      } else {
        const response = AxiosInstance.post(`${urlApi}`, data_response, header).then((response) => {
          if (response.status === 201)
            return navigate(urlRouter);
        });
      }
    }
  };

  const handleChange = (value) => {
    setStorage(value);
  }

  return (
    <>
      <CForm onSubmit={handleSubmit} className="mb-3">
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Склад</CFormLabel>
          <AsyncSelect
            cacheOptions
            loadOptions={loadOptionsAcc}
            value={storage}
            // onChange={handleChange}
            className="flex-grow-1"
            name="account"
            // defaultOptions={defaultAccountManager}
            onChange={(value) => { handleChange(value) }}
            styles={{ border: '1px solid red' }}
          />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">1c код</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput5" value={c1id} onChange={(e) => setC1id(e.target.value)} autoComplete="off" />
        </div>
        <div className="mb-3">
          <Form.Check type="checkbox" label="головний" defaultChecked={isMain} onChange={(e) => {
            setIsMain(!isMain)
          }} />
        </div>


        <div className="mb-3">
          <Editor
            apiKey={apiKey}
            onInit={(evt, editor) => editorRef.current = editor}
            initialValue={(data != undefined) ? description : ''}
            init={{
              height: 500,
              menubar: 'edit view insert format',
              plugins: [
                'advlist','autolink',
                'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks','fullscreen',
                'insertdatetime','media','table', 'help', 'code'
             ],
              toolbar: 'undo redo | fontfamily fontsize | fontselect | bold italic backcolor | ' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist checklist outdent indent | removeformat | link media a11ycheck code table help',
              content_style: 'body { font-family:FixelDisplayRegular; font-size:14px }',
              font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Fixel Display Regular=fixelDisplayRegular; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
            }}
          />
        </div>

        <CButton type="submit" color="success">Зберегти</CButton>
      </CForm>
    </>
  );
};

export default StorageElementForm;